import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import type { RootState } from '@/app/store';
import { FAQ } from '@/interfaces/faq';
import faqService from '@/api/faqService';
import { formatFaqResponse } from '@/utils/faqHelper';
import i18n from 'i18next';

interface FaqState {
  data: FAQ[];
  loading: boolean;
  error: string;
}

const initialState: FaqState = {
  data: [],
  loading: false,
  error: '',
};

export const fetchFaq = createAsyncThunk('faq/fetch', async (language: string = 'en', thunkAPI) => {
  try {
    const response = await faqService.fetchPublishedFaq();

    if (response?.questions?.length > 0) {
      return formatFaqResponse(response, language, i18n.t);
    }

    return [];
  } catch (error: any) {
    return thunkAPI.rejectWithValue(error.data);
  }
});

export const faqSlice = createSlice({
  name: 'faq',
  initialState,
  reducers: {
    clearFaq: () => initialState,
  },
  extraReducers: builder => {
    builder.addCase(fetchFaq.pending, state => {
      state.loading = true;
      state.error = '';
    });

    builder.addCase(fetchFaq.fulfilled, (state, action) => {
      state.data = Array.isArray(action.payload) ? action.payload : [];
      state.loading = false;
    });

    builder.addCase(fetchFaq.rejected, state => {
      state.loading = false;
      state.error = 'Error loading FAQ';
    });
  },
});

export const { clearFaq } = faqSlice.actions;
export const selectFaq = (state: RootState) => state.faq;
export default faqSlice.reducer;
